export const PUBLISH_RULES_FORM_ID = 'publishRulesForm';
export const PUBLISH_RULES_ADDITIONAL_SETTINGS_BLOCK_ID = 'publishRulesAdditionalBlock';
